import { IconButton, Link, LinkProps } from '@goed/ui-components';
import React, { useEffect, useState } from 'react';
import cx from 'classnames';

export type GlobalBannerProps = {
    id: string;
    title: string;
    body?: string;
    link?: LinkProps & {
        url?: string;
        openInNewWindow?: boolean;
        link?: { slug?: string };
    };
    visibleFrom: string;
    visibleUntil: string;
    variant?: 'call-to-action' | 'promo' | 'warning';
    isCloseable?: boolean;
    visibleOn?: string;
};

export const GlobalBanner = ({
    id,
    title,
    body,
    link,
    visibleFrom,
    visibleUntil,
    variant = 'call-to-action',
    isCloseable,
}: GlobalBannerProps): JSX.Element => {
    const [bannerVisible, setBannerVisible] = useState<boolean>(false);
    const bannerClassNames = cx('global-banner', `global-banner--${variant}`);
    const bannerId = `global-banner-visibility__${id}`;

    const handleClose = () => {
        setBannerVisible(false);
        localStorage.setItem(bannerId, 'false');
    };

    useEffect(() => {
        const now = new Date();
        const visibleFromDate = new Date(visibleFrom);
        const visibleUntilDate = new Date(visibleUntil);

        if (now >= visibleFromDate && now <= visibleUntilDate) {
            const storedValue = localStorage.getItem(bannerId);
            if (storedValue === null) setBannerVisible(true);
            if (storedValue !== null) setBannerVisible(JSON.parse(storedValue));
        }
    }, [bannerId, visibleFrom, visibleUntil]);

    if (!bannerVisible) return <></>;

    return (
        <div className={bannerClassNames}>
            <div className="global-banner__content">
                <h2 className="global-banner__title">{title}</h2>
                {body && <p className="global-banner__body">{body}</p>}
            </div>

            {link && (
                <Link
                    className="global-banner__link"
                    label={link.label}
                    href={link.url || `/${link?.link?.slug}`}
                    target={link.openInNewWindow ? '_blank' : undefined}
                    size="sm"
                    iconAfter="chevron-right"
                    modTextUnderline={false}
                />
            )}

            {isCloseable && (
                <IconButton
                    variant="naked"
                    iconName="x"
                    label="Close"
                    size="s"
                    className="global-banner__close"
                    onClick={handleClose}
                />
            )}
        </div>
    );
};
